/** @jsxImportSource @emotion/react */

import { useMemo } from "react";
import useDocumentDetails from "../../../../../../hooks/useDocumentDetails";
import Typography from "../../../../../../components/Typography";
import {
  DocumentStages,
  DocumentStatus,
  ResultStatus,
} from "../../../../../../graphql/__GENERATED__/types";
import DetailsSectionColumn from "../../../../../../components/Details/components/Main/Grid/DetailsSectionColumn";
import { stageLabel, statusLabel } from "./StageAndStatusLabels";
import Icon from "../../../../../../components/Icons";
import { ColorNames } from "../../../../../../theme";
import { getStatusIcon } from "../../../../../../filters/documents";
import { DetailsRowProps } from "../../../../../../components/Details/components/Main/Grid/DetailsRow";
import { formatISODate } from "../../../../../../utils/formatNumber";
import { IconNames } from "../../../../../../components/Icons/styles/iconNames";

const InsuranceInfo = () => {
  const {
    documentData: { simulationResults, stage, status, createdAt, archived },
  } = useDocumentDetails();

  const approvedResult = useMemo(() => {
    return simulationResults?.find(
      (result) => result?.status === ResultStatus.Approved
    );
  }, [simulationResults]);

  const insuranceInfo = useMemo<DetailsRowProps[]>(() => {
    return [
      {
        label: "Etapa // Status",
        value: (
          <Typography
            variant="textMedium"
            component="div"
            css={{ display: "flex", alignItems: "center", gap: 4 }}
          >
            <Icon
              name={
                archived
                  ? IconNames.Archive
                  : getStatusIcon(status as DocumentStatus)!
              }
              color={archived ? ColorNames.ERROR_RED : ColorNames.GREEN}
            />
            {archived
              ? "Arquivado"
              : `${stageLabel[stage as DocumentStages]} ${
                  statusLabel[status as DocumentStatus]
                }`}
          </Typography>
        ),
      },
      {
        label: "Tipo de Seguro",
        value: "Agrícola",
      },
      {
        label: "Data de criação",
        value: formatISODate(createdAt),
      },
    ];
  }, [approvedResult, archived, stage, status]);

  const approvedInsuranceInfo = useMemo(() => {
    return (
      approvedResult && {
        label: "Seguradora",
        value: approvedResult.provider,
      }
    );
  }, [approvedResult]);

  const info = approvedInsuranceInfo
    ? [...insuranceInfo, approvedInsuranceInfo]
    : insuranceInfo;

  return <DetailsSectionColumn xs={12} sm={6} rows={info} />;
};

export default InsuranceInfo;
